var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.907,
    x2: 404.713,
    y1: 103.903,
    y2: 390.708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.442,
    x2: 259.282,
    y1: 51.275,
    y2: 171.12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.645,
    x2: 45.366,
    y1: 93.923,
    y2: 103.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.776,
    x2: 85.497,
    xlinkHref: "#lg1",
    y1: 93.923,
    y2: 103.615
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.265,
    x2: 139.303,
    xlinkHref: "#lg2",
    y1: 89.545,
    y2: 119.583
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 366.69,
    y2: 436.718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.538,
    x2: 72.538,
    xlinkHref: "#lg3",
    y1: 157.911,
    y2: 162.535
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.502,
    x2: 63.502,
    xlinkHref: "#lg1",
    y1: 151.257,
    y2: 164.01
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.684,
    x2: 100.77,
    xlinkHref: "#lg1",
    y1: 161.547,
    y2: 217.633
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 82,
    x2: 82,
    xlinkHref: "#lg4",
    y1: 213.357,
    y2: 229.475
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.538,
    x2: 245.538,
    xlinkHref: "#lg3",
    y1: 157.911,
    y2: 162.535
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.502,
    x2: 236.502,
    xlinkHref: "#lg1",
    y1: 151.257,
    y2: 164.01
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.684,
    x2: 273.77,
    xlinkHref: "#lg1",
    y1: 161.547,
    y2: 217.633
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 213.357,
    y2: 229.475
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.538,
    x2: 418.538,
    xlinkHref: "#lg3",
    y1: 157.911,
    y2: 162.535
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.502,
    x2: 409.502,
    xlinkHref: "#lg1",
    y1: 151.257,
    y2: 164.01
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.684,
    x2: 446.77,
    xlinkHref: "#lg1",
    y1: 161.547,
    y2: 217.633
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 428,
    x2: 428,
    xlinkHref: "#lg4",
    y1: 213.357,
    y2: 229.475
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.538,
    x2: 72.538,
    xlinkHref: "#lg3",
    y1: 295.911,
    y2: 300.535
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.502,
    x2: 63.502,
    xlinkHref: "#lg1",
    y1: 289.257,
    y2: 302.01
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.684,
    x2: 100.77,
    xlinkHref: "#lg1",
    y1: 299.547,
    y2: 355.633
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 82,
    x2: 82,
    xlinkHref: "#lg4",
    y1: 351.357,
    y2: 367.475
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 252,
    x2: 252,
    y1: 429.996,
    y2: 285.871
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.538,
    x2: 245.538,
    xlinkHref: "#lg3",
    y1: 295.911,
    y2: 300.535
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.502,
    x2: 236.502,
    xlinkHref: "#lg1",
    y1: 289.257,
    y2: 302.01
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.684,
    x2: 273.77,
    xlinkHref: "#lg1",
    y1: 299.547,
    y2: 355.633
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 351.357,
    y2: 367.475
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.24,
    x2: 349.706,
    y1: 465.756,
    y2: 375.221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0227,
    stopColor: "#c8e2e6",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2928,
    stopColor: "#a7c6cf",
    stopOpacity: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5522,
    stopColor: "#8fb2be",
    stopOpacity: 0.552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7938,
    stopColor: "#81a6b5",
    stopOpacity: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(-.707 -.707 -.707 .707 2363.335 793.689)",
    gradientUnits: "userSpaceOnUse",
    x1: 1722.442,
    x2: 1722.442,
    xlinkHref: "#lg2",
    y1: 1081.99,
    y2: 1173.43
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-.707 .707 .707 .707 1870.883 -642.271)",
    gradientUnits: "userSpaceOnUse",
    x1: 1819.892,
    x2: 1690.467,
    y1: -348.556,
    y2: -405.621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fc123",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.588 424.999h-471.176c-10.721 0-19.412-8.691-19.412-19.412v-329.182c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412v329.182c0 10.721-8.691 19.412-19.412 19.412z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 135.567h-510v-59.162c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.738 112.018c-8.692 0-15.738-7.046-15.738-15.738 0-8.692 7.046-15.738 15.738-15.738 8.692 0 15.738 7.046 15.738 15.738 0 8.692-7.046 15.738-15.738 15.738z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.869 112.018c-8.692 0-15.738-7.046-15.738-15.738 0-8.692 7.046-15.738 15.738-15.738 8.692 0 15.738 7.046 15.738 15.738 0 8.692-7.046 15.738-15.738 15.738z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116 112.018c-8.692 0-15.738-7.046-15.738-15.738 0-8.692 7.046-15.738 15.738-15.738 8.692 0 15.738 7.046 15.738 15.738 0 8.692-7.046 15.738-15.738 15.738z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 335.488v70.099c0 10.721 8.691 19.412 19.412 19.412h471.176c10.721 0 19.412-8.691 19.412-19.412v-70.099z",
    fill: "url(#SVGID_6_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.121 168.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.085 168.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.515 163.529v-5.397c0-3.319-2.691-6.009-6.009-6.009h-23.148c-3.319 0-6.009 2.691-6.009 6.009v64.888c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-48.314c0-4.728-3.833-8.561-8.561-8.561h-44.961c-1.444-.001-2.615-1.172-2.615-2.616z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.348 213.552v9.467c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-9.467z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m99.38 254.042h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z",
    fill: "#3e5959"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.121 168.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.085 168.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.147c3.319 0 6.009 2.691 6.009 6.009v10.016z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.515 163.529v-5.397c0-3.319-2.691-6.009-6.009-6.009h-23.148c-3.319 0-6.009 2.691-6.009 6.009v64.888c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-48.314c0-4.728-3.833-8.561-8.561-8.561h-44.96c-1.445-.001-2.616-1.172-2.616-2.616z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.348 213.552v9.467c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-9.467z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m272.38 254.042h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z",
    fill: "#3e5959"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436.121 168.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.085 168.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.515 163.529v-5.397c0-3.319-2.691-6.009-6.009-6.009h-23.147c-3.319 0-6.009 2.691-6.009 6.009v64.888c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-48.314c0-4.728-3.833-8.561-8.561-8.561h-44.962c-1.444-.001-2.615-1.172-2.615-2.616z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.348 213.552v9.467c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-9.467z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m445.38 254.042h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z",
    fill: "#3e5959"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.121 306.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.085 306.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.515 301.529v-5.397c0-3.319-2.691-6.009-6.009-6.009h-23.148c-3.319 0-6.009 2.691-6.009 6.009v64.888c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-48.314c0-4.728-3.833-8.561-8.561-8.561h-44.961c-1.444-.001-2.615-1.172-2.615-2.616z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.348 351.552v9.467c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-9.467z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m99.38 392.042h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z",
    fill: "#3e5959"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m298.5 403.996h-93c-9.113 0-16.5-7.387-16.5-16.5v-93c0-9.113 7.387-16.5 16.5-16.5h93c9.113 0 16.5 7.387 16.5 16.5v93c0 9.112-7.387 16.5-16.5 16.5z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.121 306.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.148c3.319 0 6.009 2.691 6.009 6.009z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.085 306.147h-35.166v-10.016c0-3.319 2.691-6.009 6.009-6.009h23.147c3.319 0 6.009 2.691 6.009 6.009v10.016z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.515 301.529v-5.397c0-3.319-2.691-6.009-6.009-6.009h-23.148c-3.319 0-6.009 2.691-6.009 6.009v64.888c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-48.314c0-4.728-3.833-8.561-8.561-8.561h-44.96c-1.445-.001-2.616-1.172-2.616-2.616z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.348 351.552v9.467c0 4.728 3.833 8.561 8.561 8.561h74.181c4.728 0 8.561-3.833 8.561-8.561v-9.467z",
    fill: "url(#SVGID_27_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m272.38 392.042h-34.76c-2.223 0-4.025-1.802-4.025-4.025v-5.488c0-2.223 1.802-4.025 4.025-4.025h34.76c2.223 0 4.025 1.802 4.025 4.025v5.488c0 2.223-1.802 4.025-4.025 4.025z",
    fill: "#3e5959"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m492.746 424.872-94.749-94.749c-1.857-2.691-4.717-4.754-8.381-5.505l-93.771-19.206c-9.498-1.945-17.893 6.45-15.948 15.948l19.206 93.771c.75 3.664 2.814 6.525 5.505 8.381l1.486 1.486h184.495c.729.001 1.448-.047 2.157-.126z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m294.844 304.412 93.771 19.206c10.544 2.16 14.454 15.18 6.843 22.791l-17.432 17.432 45.655 45.655c5.08 5.08 5.08 13.316 0 18.395l-21.307 21.307c-5.08 5.08-13.316 5.08-18.395 0l-45.655-45.655-17.432 17.432c-7.611 7.611-20.631 3.701-22.791-6.843l-19.206-93.771c-1.944-9.499 6.451-17.894 15.949-15.949z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.375 449.197c-5.08 5.08-13.316 5.08-18.395 0l-45.655-45.655-17.432 17.432c-7.611 7.611-20.631 3.701-22.791-6.843l-19.206-93.771c-.973-4.749.64-9.222 3.683-12.265l130.449 130.449z",
    fill: "url(#SVGID_30_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.ea1c5a9211c59c3d2b875b7d56f97d7d.svg";
export { ForwardRef as ReactComponent };